<template>
  <div class="teacher-wrap">
    <div class="header">
      <div class="title">讲师</div>
      <div class="nav-wrap" v-if="teachers.length > 3">
        <i
          class="el-icon-arrow-left"
          :class="{ disabled: teacherIndex == 0 }"
          @click="navTeacherLeft"
        ></i>
        <span class="line"></span>
        <i
          class="el-icon-arrow-right"
          :class="{ disabled: teacherIndex >= teachers.length - 3 }"
          @click="navTeacherRight"
        ></i>
      </div>
    </div>
    <div class="list" :class="'list-' + currentTeachers.length" >
      <router-link
        :to="{
          name: 'ShowTeachersDetaial',
          params: { id: teacher.teacher_id},
          query: { route_name: 'ShowTeachers', route_label: '名师' },
        }"
        class="teacher-item"
        v-for="teacher in currentTeachers"
        :key="teacher.teacher_id"
      >
        <img class="teacher-avatar" :src="teacher.avatar" />
        <div>
          <div class="teacher-name">{{ teacher.teacher_name }}</div>
          <div class="market">{{ teacher.marketing_language }}</div>
        </div>
      </router-link>
    </div>


  </div>
</template>
<script>
export default {
  name: "CourseShowTeacher",
  props: {
    teachers: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      teacherIndex: 0,
    };
  },
  computed: {
    currentTeachers() {
      return this.teachers.slice(this.teacherIndex, this.teacherIndex + 3);
    },
  },
  methods: {
    navTeacherLeft() {
      if (this.teacherIndex == 0) {
        return;
      }
      this.teacherIndex--;
    },
    navTeacherRight() {
      if (this.teacherIndex == this.teachers.length - 3) {
        return;
      }
      this.teacherIndex++;
    },
  },
};
</script>
<style lang="scss" scoped>
.teacher-wrap {
  margin-bottom: 20px;
  overflow: hidden;
  background-color: white;
  border-radius: 5px;
  padding: 19px 30px 26px 30px;

  .header {
    margin-bottom: 21px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .title {
      font-size: 18px;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
      line-height: 24px;
    }
    .nav-wrap {
      display: flex;
      align-items: center;
      font-size: 16px;

      .line {
        width: 1px;
        height: 20px;
        background: #e6e6e6;
        margin: 0 10px;
      }

      .el-icon-arrow-left,
      .el-icon-arrow-right {
        cursor: pointer;
        color: #999999;

        &.disabled {
          cursor: not-allowed;
        }
      }
    }
  }

  .list {
    display: flex;
    justify-content: space-between;
  }

  .list-2 {
    .teacher-item {
      width: 50%;
    }
  }

  .list-3 {
    .teacher-item {
      width: 33.33%;
    }
  }

  .teacher-item {
    display: flex;

    .teacher-avatar {
      width: 54px;
      height: 54px;
      border-radius: 50%;
      box-sizing: border-box;
      margin-right: 12px;
      border: 1px solid #f3f3f3;
    }

    .teacher-name {
      font-size: 14px;
      color: rgba(51, 51, 51, 1);
      line-height: 1;
      margin-top: 10px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .market {
      font-size: 14px;
      color: #999999;
      margin-top: 6px;
    }
  }

  .swiper-box {
    padding-bottom: 35px;

    .swiper-pagination {
      bottom: 0 !important;
    }
  }
}
</style>
